'use client'

import { useRef } from "react"
import styles from "./ua.module.scss";
import Button from "@/components/button/Button";
import Icon from "@/components/icon/Icon";
import { emitEvent } from "@/components/plugins/EventListener";

export default function HeaderUserButton(props) {  
  
  const toggle = () => {
    emitEvent("show_profile_slide")
  }
  
  return <>
    <Button plain={true} className={ styles.mi + ' ' + props.className} onClick={e => toggle(e)} label={ 'Show My Profile' }>
      <Icon {...props} name="user"></Icon>
    </Button>
  </>

  
}